<template>
   <v-dialog v-model="dialog" persistent width="800px" scrollable>       
       <s3-file-browser :dialog="iconDialog" @closeDialog="iconDialog = $event" @selectIcon="selectIcon"></s3-file-browser>
       <s3-file-browser :dialog="iconActiveDialog" @closeDialog="iconActiveDialog = $event" @selectIcon="selectIconActive"></s3-file-browser>
      <v-card class="dialog_card">
        <v-card-title style="padding: 5px 5px 5px;font-size: 12pt !important;font-weight: bold;" class="dialog_title headline grey lighten-3" primary-title>
           <v-btn style="margin-left:10px;" class="btn_add" icon small @click="dialog = false">
              <v-icon>keyboard_backspace</v-icon>
            </v-btn>
           <div class="flex-grow-1"></div>
           Menu Add
           <div class="flex-grow-1"></div>
          <v-btn icon light @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="padding:0;">
            <v-container fluid>
                <v-row  class="fill-height">
                  <div class="loading" v-if="loading">
                    <v-row align="center" justify="center" class="fill-height">
                      <v-progress-circular :size="25" :width="3" color="grey" indeterminate >
                          </v-progress-circular>
                    </v-row>
                  </div>
                <v-snackbar  v-model="errorLoading" color="error" :timeout="timeout" top="top">
                  {{errorMsg}}
                </v-snackbar>
               <v-col cols="12"  xs="12" >
                  <v-text-field
                    v-model="dialogData.title"
                    hide-details
                    label="Title"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12"  xs="12" >
                  <v-text-field
                    v-model="dialogData.url"
                    hide-details
                    label="Url"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col style="text-align: left;" cols="12" xs="12" >
                  <v-text-field
                    v-model="dialogData.icon"
                    label="Icon Url"
                    outlined
                  ></v-text-field>
                  <v-btn class="file_btn" color="primary" small outlined @click="showIconDialog">
                    FileBrowser
                  </v-btn>
                </v-col>
                <v-col style="text-align: left;" cols="12" xs="12" >
                  <v-text-field
                    v-model="dialogData.activeicon"
                    label="Active Icon Url"
                    outlined
                  ></v-text-field>
                  <v-btn class="file_btn" color="primary" small outlined @click="showIconActiveDialog">
                    FileBrowser
                  </v-btn>
                </v-col>  
              </v-row>
            </v-container>
        </v-card-text>
        <v-divider></v-divider>
         <v-card-actions style="padding:5px;padding-right:10px;">
          <v-btn class="dialog_btn" color="primary" text @click="detailJson">
            Confirm
          </v-btn>
          <div class="flex-grow-1"></div>
         
        </v-card-actions>
      </v-card>
    </v-dialog>  
</template>
<script>

//import icons from './materialicon.json';
import draggable from 'vuedraggable'
export default {
    id: "#dockeBuilderDialog",
    $_veeValidate: {
        validator: 'new'
    },
     data () {
      return {
        //IconList: icons,
        draggable:{
          componentData: {
            props: {
              'two-line':true,
              'subheader':true,
              'width':"100%",
              'dense':true,
              'class':"align-center"
            },
          }
        },
        channels:[],
        channelIndex:0,
        tvIconDialog: false,
        iconDialog: false,
        iconActiveDialog: false,
        s3iconActiveDialog: false,
        IconListPage: [],
        value: '',
        dialogData: {},
        dialogIndex: -1,
        dialogState: false,
        deleteDialog: false,
        loading: false,
        successed: false,
        dialog: false,
        pageNumber: 1,
        pageSize: 15,
        typeList: [
          'object',
          'dock'
        ],
        desserts: [],
        editedIndex: -1,
        isNew: false,
        editItem: {
            title: '',
            icon: ''
        },        
        dialogLoading: false,
        dialogIsNew: false,
        errorList: [],
        error: true,
        errorLoading: false,
        errorMsg: '',
        result: [],
        isLoading: true,
        model: null,
        typeModel: 'dock',
        search: null,
        timeout: 3000       
      }
    },
    
     computed: {
      user (){
        return this.$store.getters.user;
      }
    },
    watch: {
      dialogData(val){
        this.channels=val.channels?val.channels:[];
      },
      dialog (val) {
        val || this.close()
      },
      pageNumber: {
        handler (val) {
          //this.IconListPage = this.IconList.slice((val - 1) * this.pageSize, val * this.pageSize);
        },
        deep: true   
      }
    },
    components: {
       draggable,
       FileBrowser: () => import('../FileBrowser'),
       S3FileBrowser: () => import('../S3FileBrowser'),
    },
    async created() {

    },
    mounted(){
    },
     methods: {
      clear(){
        this.dialogData = {};
        this.dialogIndex = -1;
      },
      close() {
        this.$emit('closeDialog', false);
      },      
      showIconDialog(){
        this.iconDialog = true;
      },
      showIconActiveDialog(){
        this.iconActiveDialog = true;          
      },      
      selectIcon(icon){
        this.dialogData.icon = icon;
        this.iconDialog = false;
      },
      selectIconActive(icon){        
        this.dialogData.activeicon = icon;
        this.iconActiveDialog = false;
      },
      async detailJson(){
          this.dialog = false;          
          this.$emit('saveDialog', this.dialogData);        
      },
      clearSearch(){
          this.model = '';          
      }      
    }
}
</script>
<style scoped>
.file_btn{
  text-transform: none;
  margin-top: -30px;
}
.dialog_btn{
  text-transform: none;
}
.v-virtual-scroll{
  overflow-x: hidden;
}
.json_editor{
  min-height: 500px;
  height: 100%;
}
.event_body{
   /* background-color:#e9fafb; */
}
.event_card{
   box-shadow: none;
   background-color: transparent !important;
}
.header_layout{
  margin-top: -5px;
}
.event_header{
  /* background-color:#e9fafb; */
  height: 45px;
  box-shadow: none;
  padding-top: 10px;
  border:none;
  position: fixed;
  top: 0;
  z-index: 2;
}
.icon_card{
  min-width: 100%;
}
.icon_card .v-card__text,.icon_card  .v-card__title{
 padding: 7px;
}
.icon_card .v-icon{
  font-size: 50pt;
  margin-top: 13px;
}
.card_form{
  margin:5px;
  margin-top: 60px;
}

.view_footer{
   z-index: 2;
}
.flash_box{
  float: right;
  /* margin-right: -15px; */
}
.event_status{
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
  margin-left: 6px;
  vertical-align: middle;
  margin-top: -5px;
}
.event_status_connect{
   background-color:#08b325;
   border-color: #08b325;
}
.event_status_disconnect{
   background-color: #d22727;
   border-color: #b72626;
}
.event_header_title{
  font-weight: bold;
   font-size: 15pt;
  margin: 0;
}

.event_header .v-toolbar__content{
   height: 45px;
}
.list{
  background-color:#f2f3f3;
  padding: 0 0 0;
  box-shadow: none;
  border:none;
  margin-top: 0;
}
  .event-action{
    margin-right:15px;
    min-width: auto;
    line-height: 18pt;
  }

  .loading{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left:0;
  z-index: 50;
  background-color: rgba(255, 255, 255, 0.4196078431372549);
}

  .list-item{
    border-bottom: 1px solid #c9c8c8;
  }
.table_btn{
  text-transform: unset;
}
.btn_add{
    /* bottom: 0;
    position: fixed;
    margin: 0 0 16px 16px;
    z-index: 5; */
    width: 30px !important;
    height: 30px !important;
}
.btn_add i{
  font-size: 20px !important;
}
</style>

<style>
.icon_table tbody{
display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    margin-right: -12px;
    margin-left: -12px;
}
.v-list__tile--avatar{
   height: 35px !important;
}
.v-list__tile__sub-title {
    font-size: 10pt;
}
.event_header .v-toolbar__content{
   height: 45px !important;
       display: block;
}
.item_form .v-text-field__details{
  margin: 0 !important;
}
.xs_input .v-input__control{
    min-height: 37px !important;
}
.xs_input .v-input__slot{
    margin-bottom: 3px !important;
}
.xs_input .v-label{
  font-size: 12px !important;
}
td{
  vertical-align: middle !important;
}

.jsoneditor-vue{
  height: 100%;
}
.json-save-btn{
  padding: 8px 35px !important;
  margin-bottom: 20px;
}
.yp_edit > div{
      padding-left: 10px;
    padding-right: 10px;
}
div.jsoneditor-menu{
  background-color: #dfdede !important;
  border-bottom: 1px solid #bcbcbc !important;
  color: #0c0b0b !important;
}
div.jsoneditor-menu button{
  color: #0c0b0b !important;
}
div.jsoneditor{
  border: 1px solid #b2b3b4 !important;
}
div.jsoneditor-menu > button, div.jsoneditor-menu > div.jsoneditor-modes > button{
  color: #0c0b0b !important;
}
.jsoneditor-compact,.jsoneditor-format{
 color: #0c0b0b !important;
}
.jsoneditor-poweredBy{
  color: #dfdede !important;
}
.yp_toolbar .v-toolbar__content{
height: 45px !important;
}
.xs_input .v-input__control{
    min-height: 37px !important;
}
.xs_input .v-input__slot{
    margin-bottom: 3px !important;
}
.xs_input .v-label{
  font-size: 12px !important;
}
.table_header .v-toolbar__content{
  height: 70px !important;
}
.table_search{
      padding: 5px !important;
}
.table_search .v-input__control {
  min-height: 40px !important;
}
.table_combo .v-input__control {
  min-height: 40px !important;
}
</style>